export const READ_ONLY_ROW_TEST_ID = {
  HEADING: 'row-heading',
  TITLE: 'row-title',
  DESCRIPTION: 'row-description',
  VALUE: 'row-value'
};
